import { BiSearch } from "react-icons/bi";
import { Input } from "../Input";

function SearchInput({
  value,
  setter,
  placeholder = "Search",
  customStyle = {
    width: "384px",
  },

  inputStyle,
  backgroundColor,
  iconColor = "var(--main-color)",
  onClick,
}) {
  return (
    <Input
      setter={setter}
      value={value}
      placeholder={placeholder}
      customStyle={{
        ...customStyle,
      }}
      inputStyle={{
        ...inputStyle,
      }}
      rightIcon={
        <span onClick={() => onClick && onClick()}>
          <BiSearch
            size={20}
            color={"#ccc"}
            style={{
              marginRight: "-10px",
              cursor: "pointer",
            }}
          />
        </span>
      }
      onEnter={onClick}
    />
  );
}

export default SearchInput;
